import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useMemo, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { useAuth } from '../../../context/AuthContext'
import { ADMIN } from '../../../consts'
import { useTranslation } from 'react-i18next'
import {
  checkPermission,
  PermissionAction
} from '../../../component/permissions'

export default function SidebarItem(props: {
  isMenuOpen: boolean
  link: string
  title: string
  Icon: React.FC<any>
  id: string
  dropdownList?: any
  onClick?: () => void
  tooltip?: string
}) {
  const { t } = useTranslation()
  const [main, setMain] = useState(props)
  const { currentUser } = useAuth()
  const show = useMemo(() => {
    const exclude = ['Dashboard', 'Profile', 'Support', 'FAQ']
    // TODO: Take this off later
    if (
      props.title === 'Dashboard' &&
      !ADMIN?.includes(currentUser.role?.name!)
    )
      return false
    if (
      exclude.includes(props.title) ||
      ADMIN?.includes(currentUser.role?.name!)
    )
      return true
    else if (props.dropdownList) {
      const res = props.dropdownList.filter((dropdown: any) =>
        checkPermission(currentUser, dropdown.id, PermissionAction.Read)
      )
      if (res.length > 0) {
        if (res.length === 1) {
          res[0].link = props.link + '/' + res[0].link
          setMain(res[0])
        } else setMain((prev) => ({ ...prev, dropdownList: res }))
        return true
      }
    } else return checkPermission(currentUser, props.id, PermissionAction.Read)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.title, currentUser])
  return show ?
      <div className='relative' title={props.tooltip}>
        <NavLink
          to={main.link}
          onClick={main.dropdownList?.length ? () => {} : props.onClick}
        >
          {({ isActive, isPending, isTransitioning }) => (
            <>
              <div
                className={
                  isPending ?
                    'flex flex-1 p-2 w-56 m-3 text-slate-500 transition-transform transform scale-110 duration-300 ease-in-out'
                  : isActive ?
                    `transition-transform transform scale-110 duration-300 ease-in-out flex flex-1 ${props.isMenuOpen ? 'w-fit' : 'w-full'} 
                      p-2 w-50 mx-3 border-l-4 items-center text-primary border-primary bg-primary bg-opacity-10 `
                  : `text-sm flex flex-1 text-slate-500 items-center p-2 w-56 m-3 `

                }
              >
                <props.Icon
                  className={props.isMenuOpen ? 'size-7' : 'size-6'}
                />

                {!props.isMenuOpen && <p className='px-2 '>{t(main.title)}</p>}
                {main.dropdownList?.length > 1 && (
                  <button>
                    {!props.isMenuOpen && (
                      <>
                        <FontAwesomeIcon
                          // onClick={toggleVisibility}
                          icon={faCaretDown}
                        />
                      </>
                    )}
                  </button>
                )}
              </div>

              {isActive && (
                <ul
                  className={
                    props.isMenuOpen ?
                      'absolute top-full left-0 -mt-2 w-full bg-white ml-20 rounded-md shadow-lg z-20 mr-10  pl-2 transition-transform transform scale-110 duration-300 ease-in-out'
                    : `list-disc ml-10 list-inside text-gray-800 text-sm`
                  }
                >
                  {main.dropdownList?.length > 1 &&
                    main.dropdownList?.map((item: any) => (
                      <NavLink
                        key={item.id}
                        id={item.id}
                        className={({ isActive, isPending }) =>
                          isPending ? ' '
                          : isActive ? ` text-primary `
                          : ''
                        }
                        to={props.link + '/' + item.link}
                        onClick={props.onClick}
                      >
                        <li key={item.id} className='p-3'>
                          {t(item.title)}
                        </li>
                      </NavLink>
                    ))}
                </ul>
              )}
            </>
          )}
        </NavLink>
      </div>
    : null
}
